/* eslint-disable */

(function () {
  window.dataLayer = window.dataLayer || [];

  const accordionLabel = document.querySelectorAll('.playkits-accordion-label');

  accordionLabel.forEach((element) => {
    element.addEventListener('click', () => {
      const checkbox = element.closest('.playkits-accordion-tab').querySelector('.playkits-accordion-input');

      if (!checkbox.checked) {
        let parentClass = element.closest('.accordion-kit'),
          kitClass = 'no-kit';

        for (let i = 0, l = parentClass.classList.length; i < l; i++) {
          if (/kit-/.test(parentClass.classList[i])) {
            kitClass = parentClass.classList[i];
            break;
          }
        }

        dataLayer.push({
          event: 'kitExpand',
          kitId: kitClass,
          value: '80',
          currency: 'USD',
        });
      }
    });
  });

  if (document.querySelector('.playkits-accordion-input') !== null) {
    let openedAccordions = document.querySelectorAll('.playkits-accordion-input:checked'),
      kits = [];

    openedAccordions.forEach((element) => {
      let accordionClasses = element.closest('.playkits-accordion-tab').querySelector('.accordion-kit'),
        kitClass = 'no-kit';

      for (let i = 0, l = accordionClasses.classList.length; i < l; i++) {
        if (/kit-/.test(accordionClasses.classList[i])) {
          kitClass = accordionClasses.classList[i];
          break;
        }
      }

      kits.push(kitClass);
    });

    if (kits.length > 1) {
      dataLayer.push({
        event: 'kitFind',
        kitId: kits,
        value: '80',
        currency: 'USD',
      });
    }
  }
}());
